import { post } from "./client";

/**
 * Client for the testimonial replay endpoint. On 2026-09-30 production Redis
 * was full and `survey:testimonial:submitted` events were lost, so testimonials
 * submitted that day never reached the pipeline. The endpoint re-emits the
 * event for the testimonials submitted on one UTC day that are still missing
 * from Research → Testimonials; the ones that already arrived are left alone.
 *
 * Served by a hand-written staff-bff controller.
 */

export type ReplayTestimonial = {
  surveyResponseId: string;
  externalId: string;
  /** Already in Research → Testimonials; a real run leaves it alone. */
  arrived: boolean;
};

export type ReplayResponse = {
  dryRun: boolean;
  responsesScanned: number;
  testimonialsFound: number;
  /** Testimonials not yet in Research → Testimonials — what a real run sends. */
  missing: number;
  /** How many were sent — handed to the event bus, not a confirmed delivery. */
  emitted: number;
  failed: number;
  testimonials: ReplayTestimonial[];
  requestId: string;
};

export const testimonialReplayService = {
  /**
   * `date` is a UTC calendar day, YYYY-MM-DD. `dryRun` defaults to true on
   * the server; callers always send it so a replay is never implicit.
   */
  async replay(date: string, dryRun: boolean): Promise<ReplayResponse> {
    return post<ReplayResponse>("/v1/developer/survey-testimonial-replay", {
      date,
      dryRun,
    });
  },
};
